import PlayerStats from './components/PlayerStats';
import TotalAnalysis from './components/TotalAnalysis';

export default function ReceiveAnalysis({ data }) {
  const {
    AIData: {
      AIResponse: {
        RecieveAnalysis: { PlayerA, PlayerB, PionWonOnShots },
      },
    },
  } = data;

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mb-4 border-b-1">
        <PlayerStats data={PlayerA} label="Receives" showTotal />
        <PlayerStats data={PlayerB} label="Receives" showTotal />
      </div>

      <TotalAnalysis data={PionWonOnShots} title="Receive Analysis" />
    </>
  );
}
